var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdRequest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.671,
    height: 20,
    viewBox: "0 0 18.671 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PD_Request",
    "data-name": "PD Request",
    transform: "translate(-16.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M33.863,8.271l-2.14,1.3,2.14,1.216ZM49.225,9.558l-2.1-1.276v2.475ZM35.036,0V11.452l5.446,3.1,5.467-3.12V0Zm6.078,11.221H39.886V9.993h1.228Zm-.028-2.3H39.914V7.5a1.069,1.069,0,0,1,.815-1.035.932.932,0,1,0-.864-1.585.923.923,0,0,0-.3.681H38.4a2.112,2.112,0,0,1,.669-1.539,2.087,2.087,0,0,1,1.584-.561,2.105,2.105,0,0,1,.438,4.122V8.92Z",
    transform: "translate(-14.156)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M32.966,271.846l-6.484,3.7-.155.089-.156-.089-6.464-3.675-2.716-1.544v9.41H35.662v-9.43Z",
    transform: "translate(0 -259.738)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdRequest);
export default __webpack_public_path__ + "static/media/PD-Request.50cb7d4c270465193d35490aafb226e3.svg";
export { ForwardRef as ReactComponent };